'use strict';

import util from '../util';

function initializeEvents() {
    util.narsproupload();
    $(document)

    // mobile navigation
        .on('change', '.promotion-nav-select select', function (e) {
            var newUrl = $(this).find('option:selected').val();

            if (newUrl) {
                window.location.href = newUrl;
            }
        });

    // concierge form events
    var conciergeForm = $('form[id$="_beautyconsultant"]');
    if (conciergeForm.length > 0) {
        // secure concierge access
        if (location && location.protocol === 'http:') {
            window.location.href = Urls.secureConciergeForm;
        }

        var successShown = false;
        conciergeForm.on('click', 'button#sendBtn', function(e) {
            e.preventDefault();

            $.ajax({
                url: util.appendParamToURL(Urls.customerServiceSubmit, 'source', 'concierge'),
                data: conciergeForm.serialize(),
                method: 'POST'
            }).done(function (response) {
                var conciergeModal = $('#concierge-modal');
                if (response && response.success && conciergeModal.length > 0) {
                    // show success modal
                    successShown = true;
                    var popup = new Foundation.Reveal(conciergeModal);
                    //Window height minus 80px, which sets the modal to fit inside the device's screen
                    var windowHeight = window.innerHeight - 130;

                    popup.$element.children('.modal-body').css('max-height', windowHeight);	
                    popup.open();

                    // trigger ga
                    window.history.pushState('', '', Urls.conciergeForm);
                    $(document).trigger('askanexpert');
                }
            });
        });

        $(document).on('click', '.reveal-overlay', function () {
            // trigger redirect when concierge overlay is closed
            if (successShown && $(this).css('display') == 'none') {
                successShown = false;
                window.location.href = Urls.secureConciergeForm;
            }
        });
    }
}

export default {
    init: function () {
        initializeEvents();
    }
};
